import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/waitingList/waitingList.pug?vue&type=template&id=8369f646&scoped=true&lang=pug&external"
import script from "./waitingList.view.vue?vue&type=script&lang=ts"
export * from "./waitingList.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/waitingList/waitingList.scss?vue&type=style&index=0&id=8369f646&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8369f646",
  null
  
)

export default component.exports